var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticStyle:{"width":"150px"},attrs:{"src":_vm.appLogoImage,"alt":"logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }